let prefix = '/api/sap/incoming-payments';

function getPaymentIncoming(date1, date2){
    return window.axios.get(prefix+'/index?date1='+date1+'&date2='+date2);
}
export default {
    getPaymentIncoming,
}